import { Component, ErrorInfo, ReactNode } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import Error from "./components/Error";
import { SentryErrorLevels, SentryStatusCodes, logToSentryFunction } from "./components/SentryLog";
import { EnvironmentEnum } from "@lyfegen-platform/graphql-schema/models";

interface Props {
	children: ReactNode;
	serverEnvironment: EnvironmentEnum;
}

interface State {
	hasError: boolean;
}

class ErrorBoundary extends Component<Props & RouteComponentProps, State> {
	public override state: State = {
		hasError: false,
	};

	constructor(props: Props & RouteComponentProps) {
		super(props);
		const { history } = this.props;

		history.listen(() => {
			if (this.state.hasError) {
				this.setState({
					hasError: false,
				});
			}
		});
	}

	public static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("Uncaught error:", error, errorInfo);

		logToSentryFunction({
			level: SentryErrorLevels.Warning,
			errorLog: `${error} \n ${JSON.stringify(errorInfo)}`,
			statusCode: SentryStatusCodes.InternalServerError,
			env: this.props.serverEnvironment,
		});
	}

	public override render() {
		if (this.state.hasError) {
			return <Error />;
		}

		return this.props.children;
	}
}

export default withRouter(ErrorBoundary);
